module.exports = __webpack_public_path__ + "static/img/csm_p1_51be7bb656.ad91efd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fpoe/csm_p1_51be7bb656.png
// module id = 173
// module chunks = 1